/** * @author Pawan Sadvale * @email Pawan.Sadvale@ul.com * @create date 2019-12-10 11:09:38 * @modify date 2019-12-17
11:09:38 * @desc Modal pop for delete headline */

<template>
  <div>
    <div id="modal_delete" class="modal custom" role="dialog">
      <div class="modal-dialog modal-md" :class="(from === 'launchpad' || from === 'team') && 'launchpad-dimensions'">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <section>
              <div class="col-xs-12 p-16 d-flex align-items-center justify-content-between header-wrapper" :class="from === 'launchapad' && 'h-60'">
                <div class="share-link-text fw-600 font-20">{{headerTitle}}</div>
                <img
                  class="pr-5 cursor-pointer"
                  src="/static/images/icons/emergo_modal_close.svg"
                  @click="closeConfirmPopup"
                />
              </div>
            </section>
          </div>
          <div class="modal-body m-0">
            <div class="row">
              <section v-if="from !== 'launchpad'">
                <div class="col-xs-12 body-wrapper">
                  <p v-if="deleteMember" class="team-confirm-title" :class="[teamMembersList.length ? 'mb-20' : 'mb-16']">
                    {{ deletewarnInfo.title }}
                  </p>
                  <p v-else class="confirm_title font-18" :class="[teamMembersList.length ? 'mb-20' : 'mb-40']">
                    {{ deletewarnInfo.title }}
                  </p>
                  <p v-if="customTitle" class="confirm_title text-center">"{{ customTitle }}"</p>
                  <p v-if="customMessage" class="delete-warn">{{ customMessage }}</p>
                  <!-- <p v-if="deleteMember" class="delete-warn">{{ $t('deleteMessage') }}</p> -->
                  <p v-if="deactivateAccount" class="delete-warn">{{ $t('deactivateMessage') }}</p>
                  <p class="confirm-delete fw-600" v-if="confirmMessage">{{ confirmMessage }}</p>
                  <p class="confirm-delete fw-600" v-else-if="deleteMember || deactivateAccount || customMessage">
                    {{ $t('confirmationMessage') }}
                  </p>
                </div>
              </section>
              <section v-else>
                <p class="launchpad-delete-warn">{{deletewarnInfo.title}} "{{customTitle}}". {{customMessage}}</p>
                <p class="launchpad-confirm-delete">{{$t('confirmationMessage')}}</p>
              </section>
            </div>
          </div>
          <div class="modal-footer" :class="from === 'launchpad' && 'launchpad-modal-footer'">
             <div class="col-xs-12 p-0 d-flex justify-content-end" v-if="headerTitle === 'Duplicate Certificate' || headerTitle === 'Certificado Duplicado'">
            <button type="button" class="btn emergo-btn emergo-primary-button w-58" @click="closeConfirmPopup()">
                OK
              </button>
              </div>
            <div v-else class="col-xs-12 p-0 d-flex justify-content-end col-gap-16">
              <button
                type="button"
                class="btn emergo-btn emergo-secondary-button"
                :class="getLanguage() ? 'w-210' : ''"
                @click="closeConfirmPopup"
              >
                {{ $t('noCancel') }}
              </button>
              <button type="button" class="btn emergo-btn emergo-primary-button" @click="dashboardPublishDelete()">
                {{ $t('yesProceed') }}
              </button>
            </div>
          </div>
          <loader :loadingStatus="deletewarnInfo.loaderStatus"></loader>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import Loader from './Loader.vue';

export default {
  props: {
    deletewarnInfo: {
      type: Object
    },
    teamMembersList: {
      default: () => [],
      type: Array
    },
    deleteMember: {
      required: false
    },
    customMessage: {
      type: String,
      required: false
    },
    customTitle: {
      type: String,
      required: false
    },
    deactivateAccount: {
      type: Boolean,
      required: false
    },
    confirmMessage: {
      type: String,
      required: false
    },
    headerTitle: {
      type: String,
      required: false
    },
    from: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      deleteInfo: null
    };
  },
  components: {
    Loader
  },
  methods: {
    /* dashboardPublishDelete()
     * to delete the document based on the id
     */
    async dashboardPublishDelete() {
      if (this.deletewarnInfo.file && this.deletewarnInfo.type) {
        this.$emit(
          'dashboardPublishDelete',
          this.deletewarnInfo.file,
          this.deletewarnInfo.type,
          this.deletewarnInfo.fileIndex
        );
      } else {
        this.$emit('dashboardPublishDelete');
      }
    },

    closeConfirmPopup() {
      this.$emit('closePopup');
      $('#modal_delete').modal('hide');
    },
    getLanguage() {
      return this.$i18n.locale === 'Portuguese';
    }
  }
};
</script>

<style scoped>
.team-confirm-title {
  color: #333;
  font-size: 18px;
  font-weight: 400;
}
.mb-16 {
  margin-bottom: 16px;
}
.w-58 {
  max-width: 58px;
}
.launchpad-modal-footer {
  display: flex;
  height: 76px;
}
.launchpad-confirm-delete {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  padding: 0 0 17px 20px;
}
.launchpad-delete-warn {
  font-size: 18px;
  color: #333333;
  padding: 0px 28px 16px 20px;
}
.h-60 {
  height: 60px;
}
.launchpad-dimensions {
  max-width: 500px !important;
}
.delete-team-member {
  color: #333333;
}
.custom .modal-content {
  background: #ffffff;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 5px !important;
}
.custom .modal-header {
  /* padding: 0px !important;
  background-color: #fff !important;
  border-bottom: none; */
  background: #ffffff;
  border-bottom: none;
  border-radius: 8px;
  padding: 0px;
  color: #1a1a1a;
}

.header-wrapper {
  border-bottom: 1px solid #d3d3d3;
  margin-bottom: 16px;
}
.custom .modal-header .close-btn {
  position: relative;
  top: 15px;
  right: 15px;
}
.custom .modal-body {
  /* margin-top: 5px; */
}
.custom .modal-body .confirm_title {
  margin-bottom: 8px;
  /* font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
  font-size: 24px; */
  line-height: 33px;
  /* color: #333333; */
}
.custom .modal-body .delete-warn {
  margin-bottom: 24px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
}
.custom .modal-body .confirm-delete {
  margin-bottom: 40px;
  /* font-family: 'Open Sans'; */
  /* font-style: normal; */
  /* font-weight: 700; */
  /* font-size: 18px; */
  line-height: 25px;
  color: #333333;
}
.fs-16 {
  font-size: 16px;
}
.blue_outline_cancel_button {
  background-color: #fff;
  border: 1px solid #000000;
  height: 44px;
  max-width: 184px;
  border-radius: 5px;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25);
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  color: #000000;
  padding: 10px 43px;
}
.blue_filled_Proceed_button {
  background-color: #01518a;
  border: 1px solid #01518a;
  height: 44px;
  cursor: pointer;
  min-width: 217px;
  border-radius: 5px;
  margin-top: 0px !important;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25);
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  color: #ffffff;
  line-height: 25px;
  padding: 10px 53px;
}
.w-210 {
  max-width: 210px;
}
.mb-20 {
  margin-bottom: 20px;
}

p {
  margin-bottom: 0px;
}
.mr-16 {
  margin-right: 16px;
}
.modal-footer .btn {
  width: 160px;
}

.mb-40 {
  margin-bottom: 40px;
}

/* .cancel-span{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  color: #000000;
} */

.delete {
  background: #4c9e45;
  border: 1px solid #4c9e45;
  box-sizing: border-box;
  border-radius: 20px;
  height: 36px;
  width: 160px;
  font-size: 18px;
  font-weight: 500;
  line-height: 21px;
}

.delete-span {
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #f2f2f2;
}

.custom .modal-header {
  /* padding-left: 30px;
  border-bottom: 0 none;
  background-color: white;
  padding-right: 10px;
  padding-bottom: 0; */
}

.modal-body {
  /* font-weight: 500;
  text-align: center;
  padding: 0; */
  padding-top: 0px;
}

.doc_name {
  font-size: 14px;
  font-weight: 400;
}

.custom .modal-footer {
  margin-top: 10px;
  padding-left: 16px;
  padding-right: 16px;
  background-color: #fafaf9;
  border-top: none;
  border-radius: 8px;
  max-height: 76px;
  display: flex;
}

.confirm_title {
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  word-break: break-word;
}

.modal-content {
  border-radius: 10px !important;
}

.modal-dialog {
  max-width: 600px;
}

.text-start {
  text-align: start;
}

.mb-30 {
  margin-bottom: 30px;
}

ul {
  max-height: 150px;
  overflow: auto;
  scrollbar-width: thin;
}

::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px black;
  background-color: white;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background: darkgray;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background: gray;
}

.body-wrapper {
  padding-left: 20px;
  padding-right: 28px;
  color: #333333;
}

@media screen and (max-width: 767px) {
  .xs-mb-10 {
    margin-bottom: 10px;
  }

  .flex-column {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

@media screen and (min-width: 768px) {
  .modal-footer .cancel {
    margin-right: 16px;
  }
}
</style>
